/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SavingsAccountHistoryMetaDataDto,
    SavingsAccountHistoryMetaDataDtoFromJSON,
    SavingsAccountHistoryMetaDataDtoFromJSONTyped,
    SavingsAccountHistoryMetaDataDtoToJSON,
} from './SavingsAccountHistoryMetaDataDto';

/**
 * 
 * @export
 * @interface PersonalAssetHistoryMetaDataDto
 */
export interface PersonalAssetHistoryMetaDataDto {
    /**
     * 
     * @type {SavingsAccountHistoryMetaDataDto}
     * @memberof PersonalAssetHistoryMetaDataDto
     */
    savingsAccount?: SavingsAccountHistoryMetaDataDto;
}

export function PersonalAssetHistoryMetaDataDtoFromJSON(json: any): PersonalAssetHistoryMetaDataDto {
    return PersonalAssetHistoryMetaDataDtoFromJSONTyped(json, false);
}

export function PersonalAssetHistoryMetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetHistoryMetaDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'savingsAccount': !exists(json, 'savingsAccount') ? undefined : SavingsAccountHistoryMetaDataDtoFromJSON(json['savingsAccount']),
    };
}

export function PersonalAssetHistoryMetaDataDtoToJSON(value?: PersonalAssetHistoryMetaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'savingsAccount': SavingsAccountHistoryMetaDataDtoToJSON(value.savingsAccount),
    };
}

